import type { ButtonHTMLAttributes, ReactNode } from "react";

export type ButtonVariant = "primary" | "secondary" | "quiet";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: ButtonVariant;
};

/**
 * Standard Cognito action button. Use links for navigation and Button for actions.
 */
export function Button({
  children,
  className = "",
  type = "button",
  variant = "secondary",
  ...props
}: ButtonProps) {
  return (
    <button
      className={`cui-button cui-button-${variant} ${className}`}
      type={type}
      {...props}
    >
      {children}
    </button>
  );
}
